import { FetchRequest } from 'acscp/actions';
import { FormattedMessage } from 'react-intl';
import { Dispatch } from 'redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { AppState } from 'acscp/store';
import React from 'react';
import style from './accountNotificationsPage.module.scss';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { Row } from 'acscp/components/common/row';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { AccountNotification } from 'acscp/api/models/accountNotification';
import { getAccountNotifications } from 'acscp/store/selectors/accountNotificationSelector';
import { FormattedDate } from './formattedDate';
import { Link } from 'react-router-dom';
import { NotificationMarkAsReadRequest } from 'acscp/api/requests/NotificationMarkAsReadRequest';
import { AccountNotificationTitle } from './accountNotificationsTitle';

interface AccountNotificationsPageStateProps {
    notifications: AccountNotification[];
}

interface AccountNotificationsPageOwnProps {
    closeSelf: () => void;
}

interface AccountNotificationsPageDispatchProps {
    markAsRead: (notifications: string[]) => void;
}

export class AccountNotificationsPagePresentational extends PresentationComponentBase<
    AccountNotificationsPageOwnProps, AccountNotificationsPageStateProps, AccountNotificationsPageDispatchProps, {}> {

    componentDidMount(): void {
        const unreadNotificationIds = this.props.notifications.filter(n => !n.hasBeenRead).map(n => n.id);

        if (unreadNotificationIds.length > 0) {
            this.props.markAsRead(unreadNotificationIds);
        }
    }

    render(): JSX.Element {
        return (
            <div className={style.AccountNotificationsPage}>
                <Row className={style.TextRow}>
                    <FormattedMessage
                        id={'components.accountNotificationsPage.notifications'}
                        defaultMessage={'NOTIFICATIONS'}
                    />
                    <CrossIcon
                        className={style.CrossIcon}
                        onClick={() => this.props.closeSelf()}
                        aria-label="Close"
                    />
                </Row>
                <div className={style.Separator} />
                <div className={style.AccountNotificationList}>
                   {this.props.notifications.map(notification =>
                        <div
                            className={style.Notification}
                            key={notification.id}
                        >
                            <Link to={`/trip/${notification.bookingId}`} className={style.ItemContent} >
                                <AccountNotificationTitle notification={notification} />
                                <div className={style.Message}>
                                    {notification.message}
                                </div>
                                <br/>
                                <div className={style.Date}>
                                    <FormattedDate date={notification.createdAt}/>
                                </div>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: {}): AccountNotificationsPageStateProps {
    return {
        notifications: getAccountNotifications(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): AccountNotificationsPageDispatchProps {
    return {
        markAsRead: notifications  => dispatch(new FetchRequest(new NotificationMarkAsReadRequest(notifications)))
    };
}

export const AccountNotificationsPage = connectWithRequests(mapStateToProps, mapDispatchToProps)(AccountNotificationsPagePresentational);
